import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { useContext, useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { GlobalContext } from '../../../contexts/GlobalContext';
import Button from '../../base/Button';
import Divider from '../../base/Divider';
import Loading from '../../base/Loading';
import Text from '../../base/Text';
import { StyledOption } from '../../Form/Fields/MultiSelectInput';
import { Div } from '../../helpers/StyledUtils';
import Search from '../../Search';
const ResourcesFilter: React.FC<{
  api_root: 'sources' | 'webhooks' | 'destinations';
  title?: string;
  name: string;
  delete_button?: JSX.Element;
  placeholder?: string;
  in_dropdown?: boolean;
  onBack?: () => void;
  onSubmit: () => void;
  onReset: () => void;
}> = t0 => {
  const $ = _c(75);
  const {
    api_root,
    name,
    placeholder,
    in_dropdown,
    onBack,
    title
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== name) {
    t1 = {
      name
    };
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [, t2, t3] = useField(t1);
  const {
    value
  } = t2;
  const {
    setValue,
    setTouched
  } = t3;
  const [search_term, setSearchTerm] = useState("");
  let t4;
  if ($[2] !== value) {
    t4 = value || [];
    $[2] = value;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [applied_values, setAppliedValues] = useState(t4);
  const is_initial_mount = useRef(true);
  let t5;
  let t6;
  if ($[4] !== value) {
    t5 = () => {
      if (is_initial_mount.current) {
        setAppliedValues(value || []);
        is_initial_mount.current = false;
      }
    };
    t6 = [value];
    $[4] = value;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== api_root) {
    const getLabel = model => {
      if (api_root === "webhooks") {
        return model.full_name;
      }
      return model.name;
    };
    t7 = data => data && data.models.map(model_0 => ({
      label: getLabel(model_0),
      value: model_0.id
    }));
    $[7] = api_root;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const formatOptions = t7;
  let t8;
  if ($[9] !== api_root) {
    t8 = (search_term_0, value_0) => {
      if (api_root === "webhooks") {
        return {
          limit: 250,
          full_name: search_term_0 || undefined,
          id: value_0
        };
      }
      return {
        limit: 250,
        name: search_term_0 ? {
          contains: search_term_0
        } : undefined,
        id: value_0
      };
    };
    $[9] = api_root;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const formatFilters = t8;
  let filters;
  let t10;
  let t9;
  if ($[11] !== api_root || $[12] !== formatFilters || $[13] !== search_term) {
    filters = formatFilters(search_term);
    t9 = useSWR;
    t10 = APIMethodKeys[api_root].list(filters);
    $[11] = api_root;
    $[12] = formatFilters;
    $[13] = search_term;
    $[14] = filters;
    $[15] = t10;
    $[16] = t9;
  } else {
    filters = $[14];
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== HookdeckAPI || $[18] !== api_root || $[19] !== filters) {
    t11 = () => HookdeckAPI[api_root].list(filters) as any;
    $[17] = HookdeckAPI;
    $[18] = api_root;
    $[19] = filters;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const {
    data: data_0,
    isValidating
  } = t9(t10, t11);
  let selected_filters;
  let t12;
  let t13;
  if ($[21] !== api_root || $[22] !== applied_values || $[23] !== formatFilters) {
    selected_filters = formatFilters(undefined, applied_values && applied_values.length > 0 ? applied_values : undefined);
    t12 = useSWR;
    t13 = applied_values && applied_values.length > 0 ? APIMethodKeys[api_root].list(selected_filters) : null;
    $[21] = api_root;
    $[22] = applied_values;
    $[23] = formatFilters;
    $[24] = selected_filters;
    $[25] = t12;
    $[26] = t13;
  } else {
    selected_filters = $[24];
    t12 = $[25];
    t13 = $[26];
  }
  let t14;
  if ($[27] !== HookdeckAPI || $[28] !== api_root || $[29] !== selected_filters) {
    t14 = () => HookdeckAPI[api_root].list(selected_filters) as any;
    $[27] = HookdeckAPI;
    $[28] = api_root;
    $[29] = selected_filters;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const {
    data: selected_data
  } = t12(t13, t14);
  let T0;
  let T1;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  if ($[31] !== api_root || $[32] !== data_0 || $[33] !== formatOptions || $[34] !== in_dropdown || $[35] !== isValidating || $[36] !== onBack || $[37] !== placeholder || $[38] !== search_term || $[39] !== selected_data || $[40] !== setTouched || $[41] !== setValue || $[42] !== title || $[43] !== value) {
    const selected_options = formatOptions(selected_data) || [];
    const main_options = formatOptions(data_0) || [];
    const selected_ids = new Set(selected_options.map(_temp));
    const unique_main_options = main_options.filter(o_0 => !selected_ids.has(o_0.value));
    const filtered_options = [...selected_options, ...unique_main_options];
    T1 = Div;
    if ($[53] !== api_root || $[54] !== in_dropdown || $[55] !== onBack || $[56] !== placeholder || $[57] !== search_term || $[58] !== title) {
      t20 = in_dropdown ? <Div p={3} flex={{
        gap: 3,
        direction: "column"
      }}><Div flex={{
          align: "center",
          gap: 3
        }}><Button outline={true} small={true} icon="arrow_back" onClick={onBack} /><Text semi={true}>{title || `Filter by ${api_root === "webhooks" ? "connection" : api_root}`}</Text></Div><Search placeholder={placeholder || `Find a ${api_root === "webhooks" ? "connection" : api_root}`} small={true} onChange={setSearchTerm} value={search_term} /></Div> : <Search placeholder={placeholder || `Find a ${api_root === "webhooks" ? "connection" : api_root}`} small={true} borderless={true} onChange={setSearchTerm} value={search_term} focus={true} />;
      $[53] = api_root;
      $[54] = in_dropdown;
      $[55] = onBack;
      $[56] = placeholder;
      $[57] = search_term;
      $[58] = title;
      $[59] = t20;
    } else {
      t20 = $[59];
    }
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <Divider />;
      $[60] = t21;
    } else {
      t21 = $[60];
    }
    T0 = Div;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = {
        direction: "column"
      };
      $[61] = t15;
    } else {
      t15 = $[61];
    }
    t16 = 0;
    t17 = 1;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = {
        maxHeight: "300px",
        overflowY: "auto"
      };
      $[62] = t18;
    } else {
      t18 = $[62];
    }
    t19 = filtered_options && filtered_options?.length > 0 ? filtered_options.map(o_1 => <StyledOption key={o_1.label} p={{
      x: 2,
      y: 1.5
    }} label={o_1.label} size="m" name={o_1.label} checked={value?.includes(o_1.value)} onChange={e => {
      setValue(e.currentTarget.checked ? [...(value || []), o_1.value] : (value || []).filter(v => v !== o_1.value));
      setTouched(true);
    }} />) : isValidating ? <Div p={{
      x: 3,
      y: 3
    }} flex={{
      justify: "center"
    }}><Loading /></Div> : <Div p={{
      x: 3,
      y: 3
    }}><Text muted={true}>No options</Text></Div>;
    $[31] = api_root;
    $[32] = data_0;
    $[33] = formatOptions;
    $[34] = in_dropdown;
    $[35] = isValidating;
    $[36] = onBack;
    $[37] = placeholder;
    $[38] = search_term;
    $[39] = selected_data;
    $[40] = setTouched;
    $[41] = setValue;
    $[42] = title;
    $[43] = value;
    $[44] = T0;
    $[45] = T1;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    T0 = $[44];
    T1 = $[45];
    t15 = $[46];
    t16 = $[47];
    t17 = $[48];
    t18 = $[49];
    t19 = $[50];
    t20 = $[51];
    t21 = $[52];
  }
  let t22;
  if ($[63] !== T0 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t18 || $[68] !== t19) {
    t22 = <T0 flex={t15} m={t16} p={t17} style={t18}>{t19}</T0>;
    $[63] = T0;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
    $[68] = t19;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] !== T1 || $[71] !== t20 || $[72] !== t21 || $[73] !== t22) {
    t23 = <T1>{t20}{t21}{t22}</T1>;
    $[70] = T1;
    $[71] = t20;
    $[72] = t21;
    $[73] = t22;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  return t23;
};
export default ResourcesFilter;
function _temp(o) {
  return o.value;
}